// Campus photo for /colleges/rensselaer-polytechnic-institute-profile: CC BY-SA 3.0, by UpstateNYer, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AGreeneBuildingRPI.JPG), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/rensselaer-polytechnic-institute-profile/; credited under the photo.
const photo = {
    "slug": "rensselaer-polytechnic-institute-profile",
    "alt": "The ivy-covered brick Greene Building and its lawn on the Rensselaer Polytechnic Institute campus in Troy, New York",
    "src": "/colleges/rensselaer-polytechnic-institute-profile/campus-1600.webp",
    "srcSmall": "/colleges/rensselaer-polytechnic-institute-profile/campus-800.webp",
    "srcMid": "/colleges/rensselaer-polytechnic-institute-profile/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/rensselaer-polytechnic-institute-profile/og.jpg",
    "title": "GreeneBuildingRPI",
    "author": "UpstateNYer",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AGreeneBuildingRPI.JPG",
    "read": "2026-10-01"
};

export default photo;
